import React, { useEffect } from 'react';
import IdleTimer from 'react-idle-timer';
import { useTranslation } from 'react-i18next';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faUser,
  faUsers,
  faTimes,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faCaretDown,
  faCaretRight,
  faCaretLeft,
  faHome,
  faTrash,
  faPen,
  faFilter
} from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle as farTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import ThreeppErrorBoundary from 'components/threepp/ErrorBoundary/ErrorBoundary';

import { showNeutralNotification } from 'components/common/Alert/Alert';

import NotFound from 'pages/NotFound/NotFound';
import { Home } from 'pages/Home/Home';
import { CompanyRequests } from 'pages/CompanyRequests/CompanyRequests';
import { CustomerRequests } from 'pages/CustomerRequests/CustomerRequests';
import Assessment from 'pages/Assessment/Assessment';
import Logout from 'pages/Logout/Logout';
import { ProtectedRoute } from 'components/common/ProtectedRoute/ProtectedRoute';
import Routes from 'utils/routes/appRoutes';
import { NewRecord } from 'pages/NewRecord/NewRecord';
import { NewRecordSuccess } from 'pages/NewRecord/NewRecordSuccess';
import './App.scss';
import { TemplateNotFound } from 'pages/NewRecord/TemplateNotFound';

library.add(
  faUser,
  faUsers,
  faTimes,
  faBars,
  farTimesCircle,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faCaretDown,
  faCaretRight,
  faCaretLeft,
  faHome,
  faTrash,
  faPen,
  faFilter
);

const IDLE_TIMEOUT = 60 * 60 * 1000;

export const App = () => {
  const { t } = useTranslation();

  const viewportHeightHandler = () => document.querySelector(':root').style.setProperty('--vh', `${window.innerHeight / 100}px`);

  useEffect(() => {
    viewportHeightHandler();
    window.addEventListener('resize', viewportHeightHandler);
    return () => window.removeEventListener('resize', viewportHeightHandler);
  }, []);

  const onIdle = () => {
    showNeutralNotification(t('app.loggingOut'), {
      autoHideDuration: 4000,
      onCloseCallback: () => {
        window.location.replace(Routes.logout.path);
      }
    });
  };

  return (
    <div className="app">
      <IdleTimer element={document} onIdle={onIdle} debounce={250} timeout={IDLE_TIMEOUT} />
      <Router>
        <React.Fragment>
          <ThreeppErrorBoundary>
            <Switch>
              <ProtectedRoute authenticated exact={Routes.home.exact} path={Routes.home.path} component={Home} />
              <ProtectedRoute authenticated exact={Routes.customerRequests.exact} path={Routes.customerRequests.path} component={CustomerRequests} />
              <ProtectedRoute authenticated exact={Routes.companyRequests.exact} path={Routes.companyRequests.path} component={CompanyRequests} />
              <ProtectedRoute authenticated exact={Routes.assessment.exact} path={Routes.assessment.path} component={Assessment} />
              <ProtectedRoute authenticated exact={Routes.logout.exact} path={Routes.logout.path} component={Logout} />
              <ProtectedRoute authenticated exact={Routes.newRecord.exact} path={Routes.newRecord.path} component={NewRecord} />
              <ProtectedRoute authenticated exact={Routes.newRecordSuccess.exact} path={Routes.newRecordSuccess.path} component={NewRecordSuccess} />
              <ProtectedRoute authenticated exact={Routes.templateNotFound.exact} path={Routes.templateNotFound.path} component={TemplateNotFound} />
              <ProtectedRoute authenticated exact={Routes.notFound.exact} path={Routes.notFound.path} component={NotFound} />
            </Switch>
          </ThreeppErrorBoundary>
        </React.Fragment>
      </Router>
    </div>
  );
};

export default App;
